import ConnectionIcon from '@/shared/assets/icons/connection.svg?react'
import { BaseDialog, BaseInput } from '@/shared/components'
import { BaseCopyButton } from '@/shared/components/BaseCopyButton/BaseCopyButton'

type Props = {
  modalVisible: boolean
  setModalVisible: (value: boolean) => void
  device: {
    key: string
    qrCode: string
  }
}

export const ConnectNewDevice = ({ modalVisible, setModalVisible, device }: Props) => {
  return (
    <BaseDialog
      isVisible={modalVisible}
      onAction={() => {
        setModalVisible(false)
      }}
      onClose={() => setModalVisible(false)}
      actionButtonName="Готово"
      xButton={false}
      closeButton={false}
      iconTitle={<ConnectionIcon className="text-[var(--status-purple-fill)]" />}
    >
      <div className="flex flex-col gap-6">
        <div className="flex flex-col gap-[10px]">
          <p className="text-[20px]">Подключение устройства</p>
          <span className="text-[14px] text-text-secondary">
            Введите или отсканируйте код в мобильном приложении
          </span>
        </div>
        <div className="flex flex-col gap-[6px]">
          <span className="font-klein font-medium text-sm">API для подключения</span>
          <div className="flex items-center gap-[10px]">
            <BaseInput variant="secondary" value={device.key} className="w-full" />
            <BaseCopyButton text={device.key} color="primary" />
          </div>
        </div>
        <div className="flex flex-col gap-6">
          <span className="font-klein font-medium text-text-main dark:text-white text-sm">
            QR-код для подключения
          </span>
          <img
            src={`data:image/png;base64,${device.qrCode}`}
            width={160}
            height={160}
            className="self-center"
            alt="QR-код"
          />
        </div>
      </div>
    </BaseDialog>
  )
}
